import React, { useEffect, useRef, useState } from 'react'

import { DateTime, Interval } from 'luxon'

import bemit from '@function/bemit'

import { num, formatNum } from '@root/utility'

window.DateTime = DateTime;

export default function CountDown ({ start, className, onEnded, ...props })
{
	const ref = useRef();

	const timeout_ref = useRef();

	const [ticking, setTicking] = useState(true);

	const [time, setTime] = useState();

	useEffect(function ()
	{
		if (!ticking)
		{
			onEnded();
		}
	},
	[onEnded, ticking]);

	useEffect(function ()
	{
		if (timeout_ref.current)
		{
			window.clearTimeout(timeout_ref.current);
			timeout_ref.current = undefined;
		}

		if (!ticking)
		{
			return () => void 0;
		}

		window.requestAnimationFrame(function ()
		{
			onTick(start, setTime, setTicking, timeout_ref)
		});
	},
	[start, ticking]);

	return (
		<div className={ bemit(className || 'c-countdown', props.bemit || []) }
			ref={ ref }>
			{
				time?.days > 0 ?
				(
					<span className="c-countdown__days">
						{ formatNum(time.days, '0') }j
					</span>
				)
				: undefined
			}
			{
				time?.days > 0 || time?.hours > 0 ?
				(
					<span className="c-countdown__hours">
						{ formatNum(time.hours, '0') }h
					</span>
				)
				: undefined
			}
			{
				time?.days > 0 || time?.hours > 0 || time?.minutes > 0 ?
				(
					<span className="c-countdown__minutes">
						{ formatNum(time.minutes, '00') }mn
					</span>
				)
				: undefined
			}
			{
				time ?
				(
					<span className="c-countdown__seconds">
						{ formatNum(time.seconds, '00') }s
					</span>
				)
				: undefined
			}
		</div>
	);
}

function onTick (start, setTime, setTicking, timeout_ref)
{
	const NOW = DateTime.now();

	if (NOW >= start)
	{
		return setTicking(false);
	}

	const duration = Interval.fromDateTimes(NOW, start)
	.toDuration(['days', 'hours', 'minutes', 'seconds']);

	const times =
	{
		days: num(duration.days, 0),
		hours: num(duration.hours, 0),
		minutes: num(duration.minutes, 0),
		seconds: num(duration.seconds, 0)
	};

	setTime(times);

	timeout_ref.current = window.setTimeout(function ()
	{
		onTick(start, setTime, setTicking);
	},
	1000);
}